import * as React from 'react';
import { useSelector } from 'react-redux';
import { ITooltipSchema } from '../../../repositories/price-estimator/entities/onboardings/TooltipSchema';
import { selectOnbordingData } from '../../../selectors/onbording';

/**
 * Фильтрует блоки для онбординга с реально отрендеренными блоками на странице
 * (показываем онбординг только для доступных на странице блоков)
 */
export function useGetOnbordingItems() {
  const [blockForOnbordingInPage, setBlockForOnbordingInPage] = React.useState<ITooltipSchema[]>([]);
  const onbordingAllItems = useSelector(selectOnbordingData);

  React.useEffect(() => {
    const items: ITooltipSchema[] = [];

    onbordingAllItems.forEach(item => {
      const block = document.getElementById(item.anchorBlock);

      if (block) {
        items.push(item);
      }
    });

    setBlockForOnbordingInPage(items);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return blockForOnbordingInPage;
}
